// 50 states + DC.  Keep in sync w/ functions/handlers/rest/carrier-products.js
export const STATE_NAMES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
}

export const STATE_CODES = Object.keys(STATE_NAMES).sort()

// Mirrors the 'Product Availability by State' nav link blocks in nav-links.constants.js.
export const BLOCKED_USERTYPES = ['affiliate-group', 'associate-group', 'limited-to-contracting-signature-agent']

export const DISCLAIMER =
  'Availability data is based on carrier-provided state lists and footnotes. Confirm current carrier outlines, underwriting rules, and appointment status before quoting.'

export const EMPTY_MESSAGE = 'No product availability has been added yet.'

// "Mutual of Omaha: 49 states", "Enrollment First: 46 states + DC"
export const formatStateCount = states => {
  const codes = (states || []).map(s => s.state),
    hasDC = codes.includes('DC'),
    count = codes.length - (hasDC ? 1 : 0)
  return `${count} state${count === 1 ? '' : 's'}${hasDC ? ' + DC' : ''}`
}
